<template>
  <v-select
    color="primary"
    :density="dense ? 'compact' : 'comfortable'"
    persistent-hint
    :variant="plain ? 'plain' : 'outlined'"
    :list-props="{
      density: 'comfortable'
    }"
  >
    <template v-if="$slots.item" #item="{ item, props }">
      <v-list-item v-bind="props" #title :class="{ rounded }">
        <slot name="item" :item />
      </v-list-item>
    </template>

    <template v-if="$slots.label" #label>
      <slot name="label" />
    </template>

    <template v-if="$slots.selection" #selection="{ item }">
      <slot name="selection" :item />
    </template>

    <template v-if="$slots['prepend-item']" #prepend-item>
      <slot name="prepend-item" />
    </template>
  </v-select>
</template>

<script setup lang="ts">
defineProps<{
  plain?: boolean;
  rounded?: boolean;
  dense?: boolean;
}>();
</script>

<style>
.v-list:has(.rounded) {
  padding: 0;
  width: 100%;
  background: #E4ECF5 !important;
}
.v-select__content:has(.rounded) {
  border-radius: var(--border-r-md);
}
@media (max-width: 850px) {
  .v-select__content:has(.rounded) {
    width: calc(100vw - (2 * var(--space-4)));
  }
}
</style>